import React from 'react';
import { useTheme } from '@withjoy/joykit';
import { StyledLoader, StyledLoadingWrapper } from './styles';

const strokeWidth = 4;
const loaderWidth = 36;
const widthWithSpaceForStroke = loaderWidth + strokeWidth * 4;
const radius = widthWithSpaceForStroke / 2 - strokeWidth * 2;
const axis = widthWithSpaceForStroke / 2;

export const LoadingResults = () => {
  const { colors } = useTheme();

  return (
    <StyledLoadingWrapper>
      <svg
        width={widthWithSpaceForStroke}
        height={widthWithSpaceForStroke}
        x="0px"
        y="0px"
        viewBox={`0 0 ${widthWithSpaceForStroke} ${widthWithSpaceForStroke}`}
      >
        <circle
          strokeWidth={4}
          strokeLinecap="round"
          r={radius}
          cx={axis}
          cy={axis}
          stroke={colors.mono4}
          fill="transparent"
        />
        <StyledLoader
          strokeWidth={4}
          strokeLinecap="round"
          r={radius}
          cx={axis}
          cy={axis}
        />
      </svg>
    </StyledLoadingWrapper>
  );
};
